import React from 'react'
import {Form, Dropdown, Button, Image} from 'semantic-ui-react'
import {createAPIClient} from '../../../../../services/api'
import PlanEdit from './updateplan'
import {unix} from 'moment'
import moment from 'moment'

class Plans extends React.Component {

  constructor (props) {
    super(props)
    this.state = {
      showPlanChangeModal: false,
      isLoading: false,
      plans: [],
      customer: undefined
    }
  }
  loadCustomer () {
    const api = createAPIClient()
    api.get('/api/billing/customer')
      .then(response => {
        // console.log(response)
        console.log(response.data.customer[0])
        this.setState({customer: response.data.customer[0]})
      })
      .catch(error => {
        console.log(error)
      })
  }
  componentDidMount () {
    this.loadCustomer()
  }
  finishPlanChange (update = false) {
    this.setState({
      showPlanChangeModal: false
    })
    if (update) {

      setTimeout(function () {
        window.location.href = '/settings'
      }, 1000)
      // window.location.reload(true)
    }
  }
  changePlan () {
    this.setState({
      showPlanChangeModal: true
    })
  }
  render () {
    return (
      <div>

        <h4>License info</h4>
        <p>Current plan : {this.state.customer && this.state.customer.name}</p>
        <p>Devices : {this.state.customer && this.state.customer.quantity}</p>
        <p>Plan ends : {this.state.customer && moment(this.state.customer.active_until).format("YYYY-MM-DD")}</p>
        {/*<PlanEdit*/}
          {/*defaultValue={this.state.customer && this.state.customer.subscriptions.data[0].plan.id}*/}
          {/*showPlanEdit={this.state.showPlanChangeModal}*/}
          {/*finishPlanChange={this.finishPlanChange.bind(this)}*/}
        {/*/>*/}
      </div>
    )
  }
}

export default Plans



// WEBPACK FOOTER //
// ./src/pages/settings/billing/components/plans/index.js